import {Injectable} from "@angular/core";
import {DeliveryPoint} from "@app/core/delivery-point/application/dtos/delivery-point";
import {DeliveryPointLocal} from "@app/core/delivery-point/domain/delivery-point.local";

/**
 * Use case for retrieving the current user's selected delivery point.
 */
@Injectable({
    providedIn: 'root'
})
export class GetSavedDeliveryPointUseCase {
    constructor(private deliveryPointLocal: DeliveryPointLocal) { }

    execute(): DeliveryPoint | null {
        return this.deliveryPointLocal.getSavedDeliveryPoint();
    }
}
